import { Controller } from '@hotwired/stimulus';
import { show, hide } from '../scripts/visibility';

export default class extends Controller {
  static targets = ['landlineOptionsInput', 'landlineCurrentNumberInput'];

  connect() {
    this.landlineOptionsInputTarget.addEventListener(
      'change',
      this.landlineNumberOptionUpdated.bind(this)
    );
  }

  landlineNumberOptionUpdated(e) {
    if (e.currentTarget.value === 'Keep my current landline number') {
      show({
        element: this.landlineCurrentNumberInputTarget,
      });
    } else {
      hide({ element: this.landlineCurrentNumberInputTarget });
    }
  }
}
